import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new"
import {FieldAutomationActionFormProps} from "../../../../render/automation-action-form";
import {futureOptions} from "../../../../../gd/const/automation/days-options";

const debug = false
// const debug = "DateRangeActionForm"

export default class FieldDateRange_AutomationActionForm extends React.Component<FieldAutomationActionFormProps,any> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue: _.get(props.config, 'toValue', {star: 0, end: 0})
        }
    }

    onChangeToValue = (toValue:any) => {
        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    onChangeStartValue = (option:any) => {
        const toValue = _.assign({}, this.state.toValue, {
            start: option.value
        })

        if (toValue.start > toValue.end) toValue.end = toValue.start
        this.onChangeToValue(toValue)
    }

    onChangeEndValue = (option:any) => {
        const toValue = _.assign({}, this.state.toValue, {
            end: option.value
        })

        if (toValue.end < toValue.start) toValue.start = toValue.end
        this.onChangeToValue(toValue)
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        const labelClasses = Classes("label ui5-txt-not-important-small h-36 fl-ac", {
            'w-100': this.props.field.isCustom
        })

        return (
            <React.Fragment>
                <div className="flex-r fl-ac">
                    <div className={labelClasses}>start to</div>
                    <SelectGenericNew className                     = "selector w-180"
                                      options                       = {futureOptions}
                                      value                         = {this.state.toValue.start}
                                      popoverScrollContainerClasses = "max-h-200"
                                      scrollToSelected              = {true}
                                      disabled                      = {this.props.config.disabled}
                                      onChange                      = {this.onChangeStartValue}/>
                </div>
                <div className="flex-r fl-ac">
                    <div className={labelClasses}>end to</div>
                    <SelectGenericNew className                     = "selector w-180"
                                      options                       = {futureOptions}
                                      value                         = {this.state.toValue.end}
                                      popoverScrollContainerClasses = "max-h-200"
                                      scrollToSelected              = {true}
                                      disabled                      = {this.props.config.disabled}
                                      onChange                      = {this.onChangeEndValue}/>
                </div>
            </React.Fragment>
        )
    }
}